export enum OrbitStartRoundStep {
  WAITING_SIGNATURE,
  VALIDATING_TRANSACTION,
  STARTED,
  INSUFFICIENT_GAS,
  UNKNOWN_ERROR,
  DEADLINE_EXCEEDED,
  REJECTED_BY_THE_USER,
}
